//モジュールのインポート
import 'jquery.easing/jquery.easing';  //jquery.easing読み込み
import script_burgerMenu from './modules/script_burgerMenu';          //ハンバーガーメニュー読み込み
import script_dropmenu from './modules/script_dropmenu';              //ドロップメニュー読み込み
import script_telNonPc from './modules/script_telNonPc';              //PC電話発信なし読み込み
import script_widowOpen from './modules/script_widowOpen';            //インフォメーション窓開閉読み込み
//import script_anchorCorrect from './modules/script_anchorCorrect';    //画像の遅延読込でページ内リンクがずれる時の解決
import script_webp from './modules/script_webp';                      //Webpに対応しているブラウザ判定処理読み込み
import script_picturefill from './modules/script_picturefill';        //Picturefill(<picture>とsrcsetに対応しているブラウザ判定)読み込み

//モジュール先にある関数実行
script_burgerMenu();       //ハンバーガーメニュースクリプト実行
script_dropmenu();         //ドロップメニュースクリプト実行
script_telNonPc();         //PC電話発信なしスクリプト実行
script_widowOpen();        //インフォメーション窓開閉スクリプト実行
//script_anchorCorrect();    //画像の遅延読込でページ内リンクがずれる時の解決スクリプト実行
script_webp();             //Webpに対応しているブラウザ判定処理実行
script_picturefill();      //Picturefill(<picture>とsrcsetに対応しているブラウザ判定)実行
